import { Alert, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { BaseModal } from 'components';
import { EditPartnerSchemeForm } from 'modules';

import useNotifications from 'hooks/common/useNotifications';
import useChangeSchemeMutation from './hooks/requests/useChangeSchemeMutation';

import { IEditPartnerSchemeModalProps } from './EditPartnerSchemeModal.types';
import { IEditPartnerSchemeFormParams } from 'modules/forms/EditPartnerSchemeForm';

const { Text } = Typography;

const EditPartnerSchemeModal = ({
  scheme,
  usersIds = [],
  onFinish,
  onClose,
  ...props
}: IEditPartnerSchemeModalProps) => {
  const { t } = useTranslation();
  const { notificationApi } = useNotifications();

  const { loading, refetch: changeScheme } = useChangeSchemeMutation();

  const handleFinish = async (values: IEditPartnerSchemeFormParams) => {
    const { success, errorMessage } = await changeScheme({ schemeId: values.scheme.id, usersIds });

    if (success) {
      notificationApi.success({ title: t('success.changeScheme') });
      onFinish && onFinish(values);
    } else {
      notificationApi.error({ title: t(errorMessage) });
    }

    onClose();
  };

  return (
    <BaseModal title={t('modal.editPartnerScheme.title')} width={550} onClose={onClose} {...props}>
      <Alert type="warning" title={t('modal.editPartnerScheme.warning')} />

      <Text>
        {t('modal.editPartnerScheme.accountsCount')}: <Text strong>{usersIds.length}</Text>
      </Text>

      <EditPartnerSchemeForm initialValues={{ scheme }} loading={loading} onFinish={handleFinish} />
    </BaseModal>
  );
};

export default EditPartnerSchemeModal;
